import { render, staticRenderFns } from "./RC_todo.vue?vue&type=template&id=76bf2570&scoped=true"
import script from "./RC_todo.vue?vue&type=script&lang=js"
export * from "./RC_todo.vue?vue&type=script&lang=js"
import style0 from "./RC_todo.vue?vue&type=style&index=0&id=76bf2570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf2570",
  null
  
)

export default component.exports